import React, { useState } from "react";
import { useSelector } from "react-redux";
import style from "./measurementSidebar.module.scss";
import { Button } from "../../../primary";
import { signedLockedAccess } from "../../../../utils";
import { ZoomPhoto } from "../Photos";

export const MeasurementSidebar = ({ showMeasurementModal, disabled }) => {
  const [woundImageLoading, setWoundImageLoading] = useState(true);

  const assessmentDetail = useSelector((state) => state.patient.detailAssessment);
  const { measurementData } = useSelector((state) => state.patient.newWoundMeasurements) || { loading: false, measurementData: null };

  return (
    <div className="col-4">
        <div className={style.retrace_posr}>
          <div className={`${style.patient_wound}`}>
            <ZoomPhoto
              image={measurementData?.assessedImageSASURL || measurementData?.intialImageSASURL}
              loading={woundImageLoading}
              setLoading={setWoundImageLoading}
              showBottomBtn={false}
              classes={{
                outerClass: undefined,
                innerClass: "position-relative w-100",
                shimmerClass: style.image_skeleton,
              }}
              showTopBtn={assessmentDetail?.isWoundWithoutPhoto === 0}
            />
          </div>
        </div>
      {/* )} */}
      {!assessmentDetail?.hasSkipMarker &&
        signedLockedAccess(assessmentDetail?.assessmentStage) &&
        measurementData?.status === "success" && (
          <div className={`p-2 ${style.retrace_blk}`}>
            Tap{" "}
            <Button
              type="submit"
              value="Retrace"
              id="autoMeasurement"
              onClick={() => {
                showMeasurementModal("Retrace Wound Edges");
              }}
              disabled={disabled}
            />{" "}
            to redraw wound edges.
          </div>
        )}
    </div>
  );
};
